import { render, staticRenderFns } from "./StaticSectionWebsiteName.vue?vue&type=template&id=69d7358c"
import script from "./StaticSectionWebsiteName.vue?vue&type=script&lang=js"
export * from "./StaticSectionWebsiteName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports